'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$49() {
  this.bji = null;
  this.bjj = false;
}
export { $c_Lpresto_PrestoRouter$$anon$49 as $c_Lpresto_PrestoRouter$$anon$49 };
$p = $c_Lpresto_PrestoRouter$$anon$49.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$49;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$49() {
}
export { $h_Lpresto_PrestoRouter$$anon$49 as $h_Lpresto_PrestoRouter$$anon$49 };
$h_Lpresto_PrestoRouter$$anon$49.prototype = $p;
$p.bW = (function() {
  if ((!this.bjj)) {
    this.bji = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bjj = true;
  }
  return this.bji;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$49 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$49, "presto.PrestoRouter$$anon$49", ({
  Of: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$49 as $d_Lpresto_PrestoRouter$$anon$49 };
//# sourceMappingURL=presto.-Presto-Router$$anon$49.js.map
